// import React, { useEffect, useRef, useState } from 'react';
// import ActionPanelButtons from '../../DataTable/ActionPanelButtons';
// import SvgIcon from '../../SvgIcon/SvgIcon';
// import clsx from 'clsx';

// interface UniversalTableBodyProps {
//   table: any;
//   getActions?: (row: any) => any[];
//   noDataMessage?: string;
//   enableRowClick?: boolean;
// }

// const UniversalTableBody: React.FC<UniversalTableBodyProps> = ({
//   table,
//   getActions,
//   noDataMessage = 'No hay registros disponibles.',
//   enableRowClick,
// }) => {
//   const { getTableBodyProps, page, prepareRow, columns } = table;
//   const [expandedRowId, setExpandedRowId] = useState<number | null>(null);
//   const tableRef = useRef<HTMLTableSectionElement>(null);

//   const handleRowClick = (rowId: number) => {
//     setExpandedRowId((prevId) => (prevId === rowId ? null : rowId));
//   };

//   // Resetea fila expandida si cambia la página
//   useEffect(() => {
//     setExpandedRowId(null);
//   }, [page]);

//   return (
//     <tbody {...getTableBodyProps()} ref={tableRef}>
//       {page.length > 0 ? (
//         page.map((row: any, index: number) => {
//           prepareRow(row);
//           const isExpanded = expandedRowId === index;

//           return (
//             <React.Fragment key={row.id || index}>
//               <tr
//                 {...row.getRowProps()}
//                 className={clsx(
//                   'dark:border-gray-700 transition dark:hover:bg-graydark/40',
//                   enableRowClick && 'hover:bg-gray-50 cursor-pointer'
//                 )}
//                 onClick={enableRowClick ? () => handleRowClick(index) : undefined}
//               >
//                 {row.cells.map((cell: any, cellIndex: number) => {
//                   const column = cell.column;
//                   const isLastColumn = cellIndex === row.cells.length - 1;

//                   return (
//                     <td
//                       {...cell.getCellProps()}
//                       className="text-gray-900 dark:text-gray-200 px-4 py-3 text-[15px] leading-snug"
//                     >
//                       <div className="relative flex items-center justify-between">
//                         <div>
//                           {column.customCell
//                             ? column.customCell(cell)
//                             : cell.render('Cell')}
//                         </div>

//                         {getActions && isLastColumn && (
//                           <SvgIcon
//                             name="chevron-down"
//                             className={`ml-2 transition-transform duration-200 ${
//                               isExpanded ? 'rotate-180' : ''
//                             }`}
//                           />
//                         )}
//                       </div>
//                     </td>
//                   );
//                 })}
//               </tr>

//               {isExpanded && getActions && (
//                 <tr>
//                   <td
//                     colSpan={columns.length}
//                     className="bg-[#F1F5F9] px-4 py-4 transition-colors duration-300 dark:bg-[#1E293B]"
//                   >
//                     <div className="flex flex-col gap-4">
//                       <ActionPanelButtons
//                         actions={getActions(row.original)}
//                         row={row.original}
//                       />
//                     </div>
//                   </td>
//                 </tr>
//               )}
//             </React.Fragment>
//           );
//         })
//       ) : (
//         <tr>
//           <td
//             colSpan={columns.length}
//             className="text-gray-600 dark:text-gray-300 border-b py-4 text-center"
//           >
//             {noDataMessage}
//           </td>
//         </tr>
//       )}
//     </tbody>
//   );
// };

// export default UniversalTableBody;

import React, { useEffect, useRef, useState } from 'react';
import ActionPanelButtons from '../../DataTable/ActionPanelButtons';
import SvgIcon from '../../SvgIcon/SvgIcon';
import clsx from 'clsx';

interface UniversalTableBodyProps {
  table: any;
  getActions?: (row: any) => any[];
  noDataMessage?: string;
  enableRowClick?: boolean;
}

const UniversalTableBody: React.FC<UniversalTableBodyProps> = ({
  table,
  getActions,
  noDataMessage = 'No hay registros disponibles.',
  enableRowClick,
}) => {
  const { getTableBodyProps, page, prepareRow, columns } = table;
  const [expandedRowId, setExpandedRowId] = useState<number | null>(null);
  const tableRef = useRef<HTMLTableSectionElement>(null);

  const handleRowClick = (rowId: number) => {
    setExpandedRowId((prevId) => (prevId === rowId ? null : rowId));
  };

  // Resetea fila expandida si cambia la página
  useEffect(() => {
    setExpandedRowId(null);
  }, [page]);

  // Extraer key del tableBodyProps (si existe)
  const { key: bodyKey, ...bodyProps } = getTableBodyProps();

  return (
    <tbody {...bodyProps} ref={tableRef}>
      {page.length > 0 ? (
        page.map((row: any, index: number) => {
          prepareRow(row);
          const isExpanded = expandedRowId === index;

          // Aquí extraemos key del rowProps
          const { key: rowKey, ...rowProps } = row.getRowProps();

          return (
            <React.Fragment key={rowKey}>
              <tr
                {...rowProps}
                className={clsx(
                  'dark:border-gray-700 transition dark:hover:bg-graydark/40',
                  enableRowClick && 'hover:bg-gray-50 cursor-pointer'
                )}
                onClick={enableRowClick ? () => handleRowClick(index) : undefined}
              >
                {row.cells.map((cell: any, cellIndex: number) => {
                  const column = cell.column;
                  const isLastColumn = cellIndex === row.cells.length - 1;

                  // Extraer key del cellProps
                  const { key: cellKey, ...cellProps } = cell.getCellProps();

                  return (
                    <td
                      key={cellKey}
                      {...cellProps}
                      className="text-gray-900 dark:text-gray-200 px-4 py-3 text-[15px] leading-snug"
                    >
                      <div className="relative flex items-center justify-between">
                        <div>
                          {column.customCell
                            ? column.customCell(cell)
                            : cell.render('Cell')}
                        </div>

                        {getActions && isLastColumn && (
                          <SvgIcon
                            name="chevron-down"
                            className={`ml-2 transition-transform duration-200 ${
                              isExpanded ? 'rotate-180' : ''
                            }`}
                          />
                        )}
                      </div>
                    </td>
                  );
                })}
              </tr>

              {isExpanded && getActions && (
                <tr>
                  <td
                    colSpan={columns.length}
                    className="bg-[#F1F5F9] px-4 py-4 transition-colors duration-300 dark:bg-[#1E293B]"
                  >
                    <div className="flex flex-col gap-4">
                      <ActionPanelButtons
                        actions={getActions(row.original)}
                        row={row.original}
                      />
                    </div>
                  </td>
                </tr>
              )}
            </React.Fragment>
          );
        })
      ) : (
        <tr>
          <td
            colSpan={columns.length}
            className="text-gray-600 dark:text-gray-300 border-b py-4 text-center"
          >
            {noDataMessage}
          </td>
        </tr>
      )}
    </tbody>
  );
};

export default UniversalTableBody;
